import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
// import sharedCSS from '~/components/shared.css';
import css from './index.css';

class AddressInformation extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={cs(css.addressInformation)}>
        <div className={cs(css.startingPpoint)}>
          <span className={cs(css.starting)}>{this.props.pick}</span>
          <span className={cs(css.iconTruck)}>
            <img src='/assets/icon-truck.svg'/>
            <span className={cs(css.iconUnderline)}>
              <span className={cs(css.line)} />
              <span className={cs(css.triangle)} />
            </span>
          </span>
          <span className={cs(css.point)}>{this.props.drop}</span>
        </div>
        {this.props.equipment ? <div className={cs(css.equipment)}>
                    Selected equipment type: {this.props.equipment}
        </div> : null
        }
      </div>
    );
  }
}
export default connect((state, props) => ({
}))(AddressInformation);



// WEBPACK FOOTER //
// ./src/components/rate/common/addressInformation/index.js